import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import RegionForm from '../components/RegionForm';
import { useCreateRegion } from '../hooks/useRegionMutations';
import type { RegionFormData } from '@/shared/types';

export default function RegionCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const mutation = useCreateRegion();

  const handleSubmit = (data: RegionFormData) => {
    mutation.mutate(data, { onSuccess: () => navigate('/regions') });
  };

  return (
    <div>
      <PageHeader back title={t('regions.addNew')} />
      <Card style={{ marginTop: 16 }}>
        <RegionForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
